import { useState } from "react";
import { CityData, useCities } from "@/api/city";
import { FieldInput } from "@/components/form/field-input";
import { FieldCombobox } from "@/components/form/field-combobox";
import { useFormContext } from "react-hook-form";

interface SubdistrictFormFieldsProps {
  isDisabled?: boolean;
  defaultCity?: CityData;
}

export function SubdistrictFormFields({
  isDisabled = false,
  defaultCity,
}: SubdistrictFormFieldsProps) {
  const [citySearch, setCitySearch] = useState("");
  const { data: cities } = useCities({
    cityName: citySearch,
  });

  const form = useFormContext();

  const city = form.watch("city") as CityData;
  const currentCity = city || defaultCity;
  const citiesWithoutCurrentCity = currentCity
    ? cities?.content?.filter((city) => city.id !== currentCity?.id)
    : cities?.content;
  const requiredOptions = currentCity ? [currentCity] : [];

  return (
    <>
      <FieldInput
        name="subdistrictName"
        label="District Name"
        isDisabled={isDisabled}
        hasRequiredAsterisk={!isDisabled}
      />
      <FieldCombobox
        name="city"
        label="City Name"
        search={citySearch}
        setSearch={setCitySearch}
        isDisabled={isDisabled}
        options={requiredOptions
          .concat(citiesWithoutCurrentCity ?? [])
          ?.map((city) => ({
            value: city,
            label: city.cityName,
          }))}
        hasRequiredAsterisk={!isDisabled}
      />
      <FieldInput
        name="subdistrictCode"
        label="District Code"
        isDisabled={isDisabled}
      />
    </>
  );
}
